/**
 * TanStack Query hooks for `permission-scopes-link-payout-team-invoice-automat`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	permissionScopesLinkPayoutTeamInvoiceAutomatQueryKeys,
	type CreatePermissionScopesLinkPayoutTeamInvoiceAutomatBody,
	type ListPermissionScopesLinkPayoutTeamInvoiceAutomatResponse,
	type PermissionScopesLinkPayoutTeamInvoiceAutomatRow,
} from "./api";

export function usePermissionScopesLinkPayoutTeamInvoiceAutomatList(): UseQueryResult<ListPermissionScopesLinkPayoutTeamInvoiceAutomatResponse, Error> {
	return useQuery({
		queryKey: permissionScopesLinkPayoutTeamInvoiceAutomatQueryKeys.list(),
		queryFn: list,
	});
}

export function usePermissionScopesLinkPayoutTeamInvoiceAutomatCreate(): UseMutationResult<PermissionScopesLinkPayoutTeamInvoiceAutomatRow, Error, CreatePermissionScopesLinkPayoutTeamInvoiceAutomatBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: permissionScopesLinkPayoutTeamInvoiceAutomatQueryKeys.all });
		},
	});
}

export function usePermissionScopesLinkPayoutTeamInvoiceAutomatDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: permissionScopesLinkPayoutTeamInvoiceAutomatQueryKeys.all });
		},
	});
}
